import { Injectable, inject } from '@angular/core';
import { BatchHeader } from '../interfaces';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class BatchService {
  private readonly _apiPath = 'batches';
  private readonly _api = inject(ApiService);

  getBatchesByCompany(
    articleId: string,
    companyCode: string | null,
    productionFrom: string,
    productionTo: string,
  ) {
    const params: {
      articleNumber: string;
      productionFrom: string;
      productionTo: string;
      companyCode?: string;
    } = {
      articleNumber: articleId,
      productionFrom,
      productionTo,
    };

    if (companyCode) {
      params.companyCode = companyCode;
    }

    return this._api.get<BatchHeader[]>(`${this._apiPath}`, {
      params,
    });
  }
}
